"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_3 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_4 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "table-auto bg-white mb-3 w-full rounded-md" };
const _hoisted_7 = { class: "pl-2 border-r-1 border-gray" };
const _hoisted_8 = {
    key: 0,
    class: "pl-2 py-3"
};
const _hoisted_9 = {
    key: 1,
    class: "pl-2 py-3"
};
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const toastStore_1 = require("../../stores/toast/toastStore");
const i18n_1 = require("../../common/i18n");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminLogs',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        const toastStore = (0, toastStore_1.useToastStore)();
        const router = (0, vue_router_1.useRouter)();
        const logsLoading = (0, vue_3.ref)(false);
        const logValues = (0, vue_3.ref)([]);
        const totalLogs = (0, vue_3.ref)(0);
        const listFields = (0, vue_3.ref)([
            {
                key: "createdAt",
                label: (_a = (0, i18n_1.trans)("date", "Date", "logs")) !== null && _a !== void 0 ? _a : "Date",
                value: "createdAt",
                sortable: true,
                filterable: true,
            },
            {
                key: "levelName",
                label: (_b = (0, i18n_1.trans)("level", "Level", "logs")) !== null && _b !== void 0 ? _b : "Level",
                value: "levelName",
                filterable: true,
                sortable: true,
            },
            {
                key: "tag",
                label: (_c = (0, i18n_1.trans)("tag", "Tag", "logs")) !== null && _c !== void 0 ? _c : "Tag",
                value: "tag",
                filterable: true,
                sortable: true,
            },
            {
                key: "method",
                label: (_d = (0, i18n_1.trans)("method", "Method", "logs")) !== null && _d !== void 0 ? _d : "Method",
                value: "method",
                filterable: true,
                sortable: true,
            },
            {
                key: "clientIp",
                label: (_e = (0, i18n_1.trans)("ip", "IP", "logs")) !== null && _e !== void 0 ? _e : "IP",
                value: "clientIp",
                filterable: true,
                sortable: true,
            },
            {
                key: "uri",
                label: (_f = (0, i18n_1.trans)("url", "Url", "logs")) !== null && _f !== void 0 ? _f : "Url",
                value: "uri",
                filterable: true,
                sortable: true,
            },
            {
                key: "queryString",
                label: (_g = (0, i18n_1.trans)("query", "Query", "logs")) !== null && _g !== void 0 ? _g : "Query",
                value: "queryString",
                filterable: true,
                sortable: true,
            },
            {
                key: "message",
                label: (_h = (0, i18n_1.trans)("message", "Message", "logs")) !== null && _h !== void 0 ? _h : "Message",
                value: "message",
                filterable: true,
                sortable: true,
            },
            {
                key: "context",
                label: (_j = (0, i18n_1.trans)("context", "Context", "logs")) !== null && _j !== void 0 ? _j : "Context",
                value: "context",
                filterable: true,
                sortable: true,
            },
            {
                key: "actions",
                label: (_k = (0, i18n_1.trans)("extra", "Extra", "logs")) !== null && _k !== void 0 ? _k : "Extra",
            },
        ]);
        const modalIsOpen = (0, vue_3.ref)(false);
        const modalValues = (0, vue_3.ref)([]);
        const viewExtra = (id) => {
            for (let itemKey in logValues.value) {
                if (id == logValues.value[itemKey].id) {
                    modalValues.value = logValues.value[itemKey].extra;
                }
            }
            modalIsOpen.value = true;
        };
        const loadLogs = async (params = {}) => {
            logsLoading.value = true;
            try {
                if (typeof params.createdAt === "string") {
                    const dateParts = params.createdAt.split("-");
                    params.createdAt = dateParts.join("");
                }
                const response = await (0, fetch_1.default)(router.resolve({ name: 'admin_logs_api', query: params }).href);
                const logs = [];
                if (Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach(element => {
                        if (element['@type'] !== 'Logs') {
                            return;
                        }
                        logs.push(element);
                    });
                }
                logValues.value = response['hydra:member'];
                totalLogs.value = response['hydra:totalItems'];
            }
            catch (error) {
                console.error("An error occurred while fetching logs:", error);
                throw error;
            }
            finally {
                logsLoading.value = false;
            }
        };
        (0, vue_3.onBeforeUnmount)(() => {
            logValues.value = [];
            totalLogs.value = 0;
        });
        const sortBy = (0, vue_3.ref)("createdAt");
        const sortDesc = (0, vue_3.ref)(true);
        const page = (0, vue_3.ref)(1);
        const itemsPerPage = (0, vue_3.ref)(20);
        (0, vue_3.watch)([listFields.value, page, itemsPerPage, sortBy, sortDesc], async () => {
            const filters = {};
            listFields.value.forEach((field) => {
                if (field.filterable && field.filterValue) {
                    filters[field.key] = field.filterValue;
                }
            });
            try {
                await loadLogs({
                    page: page.value,
                    itemsPerPage: itemsPerPage.value,
                    order: {
                        [sortBy.value]: sortDesc.value ? "desc" : "asc",
                    },
                    ...filters,
                });
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        }, { immediate: true });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[0] || (_cache[0] = ($event) => ((listFields).value = $event)),
                    items: logValues.value,
                    striped: "",
                    condensed: "",
                    panel: "",
                    class: "mt-4",
                    isBusy: logsLoading.value,
                    sortBy: sortBy.value,
                    "onUpdate:sortBy": _cache[1] || (_cache[1] = ($event) => ((sortBy).value = $event)),
                    sortDesc: sortDesc.value,
                    "onUpdate:sortDesc": _cache[2] || (_cache[2] = ($event) => ((sortDesc).value = $event)),
                    pagination: "",
                    currentPage: page.value,
                    "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event) => ((page).value = $event)),
                    itemsPerPage: itemsPerPage.value,
                    "onUpdate:itemsPerPage": _cache[4] || (_cache[4] = ($event) => ((itemsPerPage).value = $event)),
                    totalItems: totalLogs.value
                }, {
                    "cell-createdAt": (0, vue_2.withCtx)(({ item: log }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)(log.createdAt.slice(0, 4)) + "-" + (0, vue_2.toDisplayString)(log.createdAt.slice(4, 6)) + "-" + (0, vue_2.toDisplayString)(log.createdAt.slice(6, 8)) + " " + (0, vue_2.toDisplayString)(log.createdAt.slice(8, 10)) + ":" + (0, vue_2.toDisplayString)(log.createdAt.slice(10, 12)) + ":" + (0, vue_2.toDisplayString)(log.createdAt.slice(12)), 1)
                    ]),
                    "cell-context": (0, vue_2.withCtx)(({ item: log }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)(log.context), 1)
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item: log }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createElementVNode)("button", {
                                type: "button",
                                onClick: ($event) => (viewExtra(log.id)),
                                class: "text-blue font-bold"
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("view", "View", "logs")), 9, _hoisted_5)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "items", "isBusy", "sortBy", "sortDesc", "currentPage", "itemsPerPage", "totalItems"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: modalIsOpen.value,
                    onClose: _cache[5] || (_cache[5] = ($event) => (modalIsOpen.value = false)),
                    title: (0, vue_2.unref)(i18n_1.trans)('extra_info', 'Extra info', 'logs')
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("table", _hoisted_6, [
                            (0, vue_2.createElementVNode)("tbody", null, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(modalValues.value, (modalValue, modalValueKey) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", {
                                        class: "border-b-1 last:border-b-0",
                                        key: modalValueKey
                                    }, [
                                        (0, vue_2.createElementVNode)("th", _hoisted_7, (0, vue_2.toDisplayString)(modalValueKey), 1),
                                        (typeof modalValue === 'object')
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_8, [
                                                (0, vue_2.createElementVNode)("pre", null, (0, vue_2.toDisplayString)(JSON.stringify(modalValue, null, 2)), 1)
                                            ]))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", _hoisted_9, (0, vue_2.toDisplayString)(modalValue), 1))
                                    ]));
                                }), 128))
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
